import { coerceBooleanProperty } from "@angular/cdk/coercion";
import { Dialog, DialogModule, DialogRef } from "@angular/cdk/dialog";
import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { TestId } from "pax-ui/core";

import { Button } from "../button";
import { DialogComponent, DialogData } from "../dialog";

@Component({
  selector: "pax-bottom-navigation-panel",
  imports: [CommonModule, DialogModule, Button],
  templateUrl: "./bottom-navigation-panel.html",
  styleUrls: ["./bottom-navigation-panel.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BottomNavigationPanel {
  @Input({ required: true })
  isBusy!: boolean;

  @Input()
  infoDialog?: InfoDialog | undefined;

  @Input({ transform: coerceBooleanProperty })
  enableSkipButton!: boolean;

  continueButtonTestId = TestId.CONTINUE_BUTTON;
  skipButtonTestId = TestId.SKIP_BUTTON;

  @Input()
  skipButtonText = $localize`Überspringen`;

  @Input()
  continueButtonText = $localize`Weiter`;

  @Input()
  continueButtonHint?: string;

  @Output()
  continue = new EventEmitter<void>();

  @Output()
  skip = new EventEmitter<void>();

  dialogRef?: DialogRef<DialogComponent>;

  constructor(public readonly _dialog: Dialog) {}

  openDialog() {
    this.dialogRef = this._dialog.open<DialogComponent>(DialogComponent, {
      width: "clamp(300px, 70%, 600px)",
      height: "auto",
      data: {
        ...this.infoDialog,
        showCloseButton: true,
      },
    });
  }
}

export interface InfoDialog extends DialogData {
  buttonLabel?: string;
}
